import React from 'react';
import { BookOpen, Mail, Lock, ArrowRight, Loader2 } from 'lucide-react';

interface LoginFormProps {
  email: string;
  setEmail: (email: string) => void;
  password: string;
  setPassword: (password: string) => void;
  handleLogin: (e: React.FormEvent) => void;
  isLoading?: boolean;
  onForgot: () => void;
}

const LoginForm: React.FC<LoginFormProps> = ({ email, setEmail, password, setPassword, handleLogin, isLoading = false, onForgot }) => (
  <div className="right-panel">
    <div className="right-panel-content">
      <div className="mobile-header">
        <div className="mobile-logo">
          <BookOpen size={18} color="white" />
        </div>
        <h2 className="mobile-title">MARCIAL PONS</h2>
      </div>
      <div className="login-form-container">
        <div className="login-header">
          <h2>ACCESO SISTEMA</h2>
          <p>Introduce tus credenciales para continuar.</p>
        </div>
        <form onSubmit={handleLogin} className="login-form">
          <div className="form-group">
            <label className="form-label">Usuario / Email</label>
            <div className="input-container group">
              <Mail size={18} className="input-icon" />
              <input
                required
                disabled={isLoading}
                className="login-input"
                placeholder="admin@marcialpons.es o usuario"
                type="text"
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-label-row">
              <label className="form-label">Contraseña</label>
              <a href="#" className="hover-underline" onClick={(e) => { e.preventDefault(); onForgot(); }}>¿Olvidaste?</a>
            </div>
            <div className="input-container group">
              <Lock size={18} className="input-icon" />
              <input
                required
                disabled={isLoading}
                className="login-input"
                placeholder="••••••••"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={isLoading}
            className={`login-button group ${isLoading ? 'is-loading' : ''}`}
          >
            <span className="button-text">INICIAR SESIÓN</span>
            <span className="button-icon-wrapper">
              <ArrowRight size={18} className="arrow-icon" />
              <Loader2 size={18} className="spinner-icon" />
            </span>
          </button>
        </form>
        <div className="login-footer">
          <p>Acceso restringido a personal autorizado. <br />Todas las conexiones son monitorizadas.</p>
        </div>
      </div>
    </div>
  </div>
);

export default LoginForm;
